export class PatternMatch {
  // 模糊匹配
  static fuzzyMatch(source: string | number, searchInput: string) {
    if (!searchInput) return true;
    return new RegExp(
      `(.*)(${searchInput.split("").join(")(.*)(")})(.*)`,
      "i"
    ).test(source);
  }
  static isIP(value: string) {
    return new RegExp(
      /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
      "i"
    ).test(value);
  }
  static isCIDR(value: string) {
    return new RegExp(
      /^(?:\b[0-9]{1,2}|1[0-9]{2}|2[0-4][0-9]|25[0-5]\b)\.(?:\b[0-9]{1,2}|1[0-9]{2}|2[0-4][0-9]|25[0-5]\b)\.(?:\b[0-9]{1,2}|1[0-9]{2}|2[0-4][0-9]|25[0-5]\b)\.(?:\b[0-9]{1,2}|1[0-9]{2}|2[0-4][0-9]|25[0-5]\b)\/(3[0-2]|[12]?[0-9])$/,
      "i"
    ).test(value);
  }
}
